import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import WorkspaceSetup from '../pages/WorkspaceSetup';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

/**
 * Route wrapper that requires authentication and an active tenant.
 * Redirects to landing page if not authenticated.
 * Shows workspace setup if authenticated but no tenant selected.
 */
function ProtectedRoute({ children }: ProtectedRouteProps) {
  const { isAuthenticated, isLoading, hasTenant } = useAuth();
  const location = useLocation();

  // Show loading state while checking auth
  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary-600"></div>
      </div>
    );
  }

  // Redirect to login if not authenticated
  if (!isAuthenticated) {
    return <Navigate to="/" state={{ from: location }} replace />;
  }

  // Show workspace setup if no tenant selected
  if (!hasTenant) {
    return <WorkspaceSetup />;
  }

  return <>{children}</>;
}

export default ProtectedRoute;
